import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { parseHtmlHelper, successMessageToast } from 'helpers/common';
import { Formik } from 'formik';
import { useUpdateSingleTaskMutation } from 'store/services/V2/TaskPlan';
import { cloneDeep } from 'lodash';
import { useParams } from 'react-router-dom';
import { PaperClipIcon } from 'Assets/icons/v2';
import { extractUploadFileName } from 'config/constants';
import TaskPlanEditor from './TaskPlanEditor';
import LoadingOverlay from '../LoadingOverlay';
import SessionsList from './SessionsList';

function SupportTask1({ data, sessionsCount, taskPlanRefetch }) {
    const params = useParams()
    const [descEdit, setDescEdit] = useState(false)
    const [strategyEdit, setStrategyEdit] = useState(false)

    const [updateSingleTask, { isLoading }] = useUpdateSingleTaskMutation()


    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = await cloneDeep(values)
            const { strategy, ...rest } = payload;

            const finalPayload = {
                ...rest,
                strategy: payload?.strategy?.map((list) => ({
                    ...list,
                    strategyRadio: list?.strategyRadio || "",
                    template_id: list?.template_id?.toString() || "",
                    stragety_id: list?.stragety_id?.toString() || "",
                    title: list?.title || "",
                    attachments: list?.attachments || []
                }))
            };
            const resp = await updateSingleTask({ values: finalPayload, id: data?.id }).unwrap()

            if (resp.status === "success") {
                successMessageToast(resp?.message)
            }
            setDescEdit(false)
            setStrategyEdit(false)

        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false)
        }
    }
    return (
        <>
            {isLoading && <LoadingOverlay />}
            <Formik
                initialValues={{
                    attachments: data?.attachments,
                    task_title: data?.task_name,
                    description: data?.task_description || "",
                    strategy: data?.strategy
                }}
                onSubmit={handleSubmit}
            >
                {({ handleSubmit, values, isSubmitting }) => (
                    <Form onSubmit={handleSubmit}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }} className='px-3 py-2 bg-white'>
                            <h3 className='support-staff-text-head'>Task Name</h3>
                            <p className='support-staff-text-content'>{values?.task_title || "-"} </p>
                            <div className="d-flex justify-content-between">
                                {/* <div>
                                    <h3 className='support-staff-text-head'>Task Description</h3>
                                    <div className='d-flex gap-1'>
                                        {
                                            descEdit ?
                                                <>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setDescEdit(false)
                                                        }}
                                                        style={{ color: "#315d99" }}
                                                        className='bg-transparent border-0 support-staff-head text-decoration-underline'
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        disabled={isSubmitting}
                                                        style={{ color: "#93278F" }}
                                                        className='bg-transparent border-0 support-staff-head text-decoration-underline'
                                                    >
                                                        {isSubmitting ? 'Saving...' : 'Save'}
                                                    </button>
                                                </> :
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        setDescEdit(true)
                                                    }}
                                                    style={{ color: "#93278F" }}
                                                    className='bg-transparent border-0 support-staff-head text-decoration-underline'
                                                >
                                                    Edit
                                                </button>
                                        }
                                    </div>
                                </div> */}

                                <div>
                                    <h3 className='support-staff-text-head'>Task Description</h3>
                                    {
                                        descEdit ? <div>
                                            <p className='support-staff-description mb-2' style={{ color: "#315D99" }}>Add/edit a description for the whole task plan which includes all the tasks you want the recipient to work on. You can update this description even once the task plan is in progress.</p>
                                            <TaskPlanEditor name={"description"} attachmentName={'attachments'} />
                                        </div> :
                                            <div>
                                                <p className='support-staff-description mb-0'>
                                                    {parseHtmlHelper(values?.description)}
                                                </p>
                                                <div className='d-flex flex-column gap-2'>
                                                    {
                                                        values?.attachments?.map((atch, index) => (
                                                            <div style={styles.wrapper} onClick={() => window.open(atch?.attachment_key)}>
                                                                <PaperClipIcon stroke="#93278F" />
                                                                <span style={styles.fileText}>
                                                                    {
                                                                        extractUploadFileName(atch?.attachment_key)
                                                                    }
                                                                </span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>

                            <div className='d-flex flex-column gap-3'>
                                {
                                    values?.strategy?.length > 0 ? values.strategy.map((item, index) => (
                                        <div key={item?.id || index} className='d-flex flex-column gap-2'>
                                            <div>
                                                <h3 className='support-staff-text-head'>Strategy Name</h3>
                                                <p className='support-staff-text-content'>{item?.title || "-"} </p>
                                            </div>
                                            <div>
                                                <h3 className='support-staff-text-head'>Strategy Description</h3>
                                                <p className='support-staff-description'>
                                                    {item?.text ? parseHtmlHelper(item?.text) : "-"}
                                                </p>
                                            </div>

                                            <div className='d-flex flex-column gap-2'>
                                                {
                                                    item?.attachments?.map((atch, idx) => (
                                                        <div
                                                            key={idx}
                                                            style={styles.wrapper}
                                                            onClick={() => window.open(atch?.attachment_key)}
                                                        >
                                                            <PaperClipIcon stroke="#93278F" />

                                                            <span style={styles.fileText}>
                                                                {extractUploadFileName(atch?.attachment_key)}
                                                            </span>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    )) : "-"}
                            </div>
                        </div>
                        <div className="staff-divider"></div>
                    </Form>
                )}
            </Formik>

            <div>
                <SessionsList
                    taskId={data?.id}
                    taskPlanId={params?.taskPlanId}
                    clientId={params?.clientId}
                    sessionsCount={sessionsCount}
                    taskStatus={data?.status}
                    taskPlanRefetch={taskPlanRefetch}
                />
            </div>
        </>
    )
}

export default SupportTask1

const styles = {
    wrapper: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        border: "1.5px solid #93278F",
        borderRadius: "10px",
        padding: "10px 14px",
        width: "100%",
        background: "#F7F1F8",
        cursor: "pointer",
    },

    fileText: {
        color: "#93278F",
        textDecoration: "underline",
        fontSize: "14px",
        fontWeight: 500,
    },
};
